import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IGameData, Place } from 'js/bubbleCore/types';
import {
  IEvent,
  createBubbleTransferEvent,
} from 'js/bubbleCore/events';
import { removeFromPlace } from 'js/bubbleCore/handlers/removeFromPlace';
import { addToPlace } from 'js/bubbleCore/handlers/addToPlace';

export function transferBubble(
  bubble: Bubble,
  data: IGameData,
  toPlace: Place,
  events: IEvent[] = [],
): IEvent[] {
  const fromPlace = findCurrentBubblePlace(bubble, data);
  if (fromPlace === toPlace) return events;
  if (fromPlace) removeFromPlace(bubble, data, fromPlace);
  addToPlace(bubble, data, toPlace);
  bubble.place = toPlace;
  events.push(createBubbleTransferEvent(bubble, toPlace, fromPlace));
  return events;
}

function findCurrentBubblePlace(bubble: Bubble, data: IGameData): Place | null {
  if (data.shooter.bubblesQueue.includes(bubble)) return Place.Shooter;
  if (data.shootingSpace.values.includes(bubble)) return Place.ShootingSpace;
  if (data.popOutSpace.values.includes(bubble)) return Place.PopOutSpace;
  if (Object.values(data.grid.values).includes(bubble)) return Place.Grid;
  return null;
}